import React from 'react';
import '../styles/Footer.css';

function Footer() {
  const smoothScroll = (e, targetId) => {
    e.preventDefault();
    const target = document.querySelector(targetId);
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">
            <h3>TRÔ YOGA</h3>
            <p>The Power of Neutrality</p>
          </div>
          <div className="footer-links">
            <a href="#home" onClick={(e) => smoothScroll(e, '#home')}>Home</a>
            <a href="#principles" onClick={(e) => smoothScroll(e, '#principles')}>Principles</a>
            <a href="#power-yoga" onClick={(e) => smoothScroll(e, '#power-yoga')}>Power Yoga</a>
            <a href="#ai-chat" onClick={(e) => smoothScroll(e, '#ai-chat')}>TRO AI</a>
            <a href="#contact" onClick={(e) => smoothScroll(e, '#contact')}>Contact</a>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} TRO Yoga. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
